// extracted by mini-css-extract-plugin
export default {"root":"Initials_root__vcARS"};